import { FormLabel } from "@chakra-ui/react";

export const Label = (props: any) => <FormLabel pt="20px" fontWeight={"bold"} {...props} />;
